<!-- Skeleton Loader for Hairstyle Details -->
<div class="min-h-screen bg-white">
  <!-- Header with back button -->
  <div class="bg-primary-light py-4 px-4 lg:px-0">
    <div class="container mx-auto">
      <div class="flex items-center gap-2 animate-pulse">
        <div class="h-5 w-5 bg-gray-200 rounded"></div>
        <div class="h-5 bg-gray-200 rounded w-40"></div>
      </div>
    </div>
  </div>

  <div class="container mx-auto py-8 lg:py-12 px-4">
    <!-- Images Gallery Skeleton -->
    <div class="mb-8">
      <div class="relative h-64 md:h-80 lg:h-96 rounded-xl overflow-hidden border-2 border-gray-200 bg-gray-200 animate-pulse">
        <!-- Navigation buttons skeleton -->
        <div class="absolute left-4 top-1/2 -translate-y-1/2 z-20 p-3 bg-white/90 rounded-full shadow-lg">
          <div class="h-6 w-6 bg-gray-200 rounded"></div>
        </div>
        <div class="absolute right-4 top-1/2 -translate-y-1/2 z-20 p-3 bg-white/90 rounded-full shadow-lg">
          <div class="h-6 w-6 bg-gray-200 rounded"></div>
        </div>
      </div>
    </div>

    <!-- Hairstyle Info Skeleton -->
    <div class="mb-12">
      <!-- Title Skeleton -->
      <div class="h-10 lg:h-12 bg-gray-200 rounded w-3/4 mb-3 animate-pulse"></div>
      
      <!-- Time info skeleton -->
      <div class="flex flex-wrap items-center gap-6 mb-6">
        <div class="flex items-center gap-2 animate-pulse">
          <div class="h-6 w-6 bg-gray-200 rounded"></div>
          <div class="h-6 bg-gray-200 rounded w-24"></div>
        </div>
      </div>

      <!-- Description Skeleton -->
      <div class="space-y-3 animate-pulse">
        <div class="h-4 bg-gray-200 rounded w-full"></div>
        <div class="h-4 bg-gray-200 rounded w-full"></div>
        <div class="h-4 bg-gray-200 rounded w-5/6"></div>
      </div>
    </div>

    <!-- Hairdressers Section Skeleton -->
    <div class="border-t border-gray-200 pt-8">
      <!-- Section Title Skeleton -->
      <div class="h-8 lg:h-9 bg-gray-200 rounded w-2/3 mb-6 animate-pulse"></div>

      <!-- Hairdressers Grid Skeleton -->
      <div class="grid grid-cols-2 gap-3 lg:grid-cols-3 xl:grid-cols-4">
        @for (item of [1, 2, 3, 4, 5, 6, 7, 8]; track $index) {
          <div class="flex flex-col gap-2 animate-pulse">
            <div class="h-36 bg-gray-200 rounded-lg"></div>
            <div class="h-4 bg-gray-200 rounded w-3/4"></div>
            <div class="h-3 bg-gray-200 rounded w-1/2"></div>
          </div>
        }
      </div>
    </div>
  </div>
</div>

